<form (keydown.enter)="$event.preventDefault()" [formGroup]="formGroup"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="unsaved-warning" *ngIf="warnUnsaved">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>This show has unsaved changes. Leaving discards them.</span>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" style="flex-grow:1">
      <mat-label>Comment{{ commentRequired ? '' : ' (optional)' }}</mat-label>
      <textarea matInput type="text" placeholder="Enter comment..." formControlName="comment">

      </textarea>
    </mat-form-field>
  </div>
</form>
